import moment from "moment";

export const BirthDateFilter = (d: Date): boolean => {
	const startDateValue18 = moment(new Date()).add(-18, "y");
	const startDateValue130 = moment(new Date()).add(-130, "y");
	if (startDateValue18 || startDateValue130) {
		if (moment(d) < startDateValue18) {
			if (moment(d) < startDateValue130) {
				return false;
			} else {
				return true;
			}
		}
	} else {
		return true;
	}
};
